<script>
import { VBTooltip } from 'bootstrap-vue';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  props: {
    form: {
      type: Object,
      required: true,
    },

    field: {
      type: Object,
      required: true,
    },

    saving: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  mounted () {
    this.getLinks();
  },

  data () {
    return ({
      localId: 0,
      tooltip: {
        html: true,
        title: '<a target="_blank" rel="noopener noreferrer" style="color: #fff" href="https://salesflowcrm.movidesk.com/kb/article/405401/o-que-e-placeholder-e-mascara-para-que-servem">Clique para saber mais</a>',
      },
      modal: {
        title: null,
        question: null,
        name: null,
        type: 'text',
        cols: null,
        rules: 'required',
        mask: '',
        placeholder: '',
        step: null,
      },
      terms_url: '',
      politics_url: '',
      options: [
      //
      ],
      questionTypes: [
        {
          text: null,
          value: null,
        },
        {
          text: this.__('Campo de texto'),
          value: 'text',
        },
        {
          text: this.__('Campo de área'),
          value: 'textarea',
        },
        {
          text: this.__('Selecionar de uma lista'),
          value: 'select',
        },
        {
          text: this.__('Label'),
          value: 'label',
        },
        {
          text: this.__('Selecionar opção'),
          value: 'radio',
        },
        {
          text: 'Checkbox',
          value: 'checkbox',
        },
        {
          text: this.__('Data'),
          value: 'date',
        },
        {
          text: this.__('Hora'),
          value: 'time',
        },
        {
          text: 'E-mail',
          value: 'email',
        },
        {
          text: this.__('Numérico'),
          value: 'number',
        },
      ],
    });
  },

  computed: {
    requiredCheck () {
      return (this.modal.rules || '').indexOf('required') !== -1;
    },

    showMask () {
      return ['date', 'time'].includes(this.modal.type) === false;
    },

    showOptions () {
      const {
        type,
      } = this.modal;

      return type === 'select' || type === 'radio' || type === 'checkbox';
    },
  },

  methods: {
    checkRequired () {
      const {
        rules,
      } = this.modal;

      if ((rules && rules.indexOf('required') === -1) || ! rules) {
        return this.modal.rules = rules ? (`${rules}|required`) : 'required';
      }

      this.modal.rules = rules.replace('required|', '').replace('required', '');
    },

    addOption () {
      this.options.push({});
    },

    removeOption (option) {
      if (! option.id) {
        return this.options.splice(this.options.indexOf(option), 1);
      }

      this.$http.delete(`/form/${this.form.id}/question/${this.modal.id}/option/${option.id}`)
        .then(() => {
          this.options.splice(this.options.indexOf(option), 1);
        })
        .catch(() => {
          Alert.error(this.__('Erro ao remover opção'));
        });
    },

    setPlaceholder () {
      const {
        terms_url = '',
        politics_url = '',
        field: {
          name,
        },
      } = this;

      if (name !== 'consent-term') {
        return;
      }

      this.modal.placeholder = `Ao informar meus dados, eu concordo com a <a target="_blank" href="${politics_url}" style="color: black">Política de Privacidade</a> e com os <a target="_blank" href="${terms_url}" style="color: black">Termos de Uso</a>.`;
    },

    getLinks () {
      const {
        field: {
          name = '',
          placeholder = '',
        },
      } = this;

      if (name !== 'consent-term' || ! placeholder) {
        return;
      }

      const [
        first = '',
        second = '',
      ] = placeholder.match(/\bhttps?:\/\/\S+/gi) || [];

      this.politics_url = first.replace('"', '');
      this.terms_url = second.replace('"', '');
    },
  },

  beforeDestroy () {
    /**
    * To force save changes
    */
    this.$emit('save', { ...this.modal, options: this.options });
  },

  watch: {
    'field': {
      handler (value) {
        /**
        * To save current changes
        */
        if (this.modal.question) {
          this.$emit('save', { ...this.modal, options: this.options });
        }

        this.modal = { ...this.modal, ...value };

        this.getLinks();

        this.options = value.options;
      },

      immediate: true,
    },

    'modal.type': function () {
      /**
      * To instant update type of field
      */
      this.$emit('save', { ...this.modal, options: this.options });
    },

    'modal.question': {
      handler: _.debounce(function () {
        if (this.field.id !== this.localId) {
          this.localId = this.field.id;

          return;
        }

        /**
      * To instant update question of field
      */
        this.$emit('save', { ...this.modal, options: this.options });
      }, 250, { maxWait: 1000 }),
    },

    'politics_url': {
      handler () {
        this.setPlaceholder();
      },

      immediate: false,
    },

    'terms_url': {
      handler () {
        this.setPlaceholder();
      },

      immediate: false,
    },
  },
};
</script>

<template>
  <div
    class="form-builder-prop"
  >
    <div
      class="row"
    >
      <div
        class="col-md-12"
      >
        <div
          class="form-group"
        >
          <label>
            {{ __('Título do campo') }}
          </label>

          <input
            required
            type="text"
            name="question"
            class="form-control"
            v-model="modal.question"
          >
        </div>
      </div>

      <div
        class="col-md-12"
      >
        <div
          class="form-group"
        >
          <label>
            {{ __('Tipo de campo') }}
          </label>

          <select
            required
            autofocus
            name="type"
            v-model="modal.type"
            class="form-control"
          >
            <option
              v-for="current in questionTypes"
              :key="current.value"
              :value="current.value"
              v-text="current.text"
            />
          </select>
        </div>
      </div>

      <div
        v-if="showOptions"
        class="col-md-12"
      >
        <div
          :key="index"
          v-for="(option, index) in options"
        >
          <div
            class="input-group"
          >
            <input
              type="text"
              class="form-control"
              v-model="option.option"
              :placeholder="'Opção ' + parseInt(index + 1, 10)"
            >

            <span
              @click="removeOption(option)"
              class="input-group-text pointer danger"
            >

              <span class="fa fa-times" />
            </span>
          </div>
          <br>
        </div>

        <div
          class="col-md-12"
        >
          <div
            class="form-group"
          >
            <input
              readonly
              type="text"
              name="options"
              @click="addOption()"
              style="cursor: pointer"
              class="form-control opacity"
              :placeholder="__('Clique para adicionar uma opção')"
            >
          </div>
        </div>
      </div>

      <div
        class="col-md-12"
      >
        <div
          class="form-group"
        >
          <template
            v-if="modal.name === 'consent-term'"
          >
            <label>
              {{ __('Link - Políticas de Privacidade') }}
            </label>

            <input
              type="url"
              name="politics"
              class="form-control"
              v-model="politics_url"
            >

            <label>
              {{ __('Link - Termos de uso') }}
            </label>

            <input
              type="url"
              name="terms"
              v-model="terms_url"
              class="form-control"
            >
          </template>

          <template
            v-else
          >
            <label>
              Placeholder

              <a
                target="_blank"
                rel="noopener noreferrer"
                v-b-tooltip.bottom="tooltip"
                class="form-builder-prop__info"
                href="https://salesflowcrm.movidesk.com/kb/article/405401/o-que-e-placeholder-e-mascara-para-que-servem"
              >
                <span
                  class="form-builder-prop__info-trigger"
                >
                  ?
                </span>
              </a>
            </label>

            <input
              type="text"
              name="placeholder"
              class="form-control"
              v-model="modal.placeholder"
            >
          </template>
        </div>
      </div>

      <div
        class="col-md-12"
        v-if="showMask && modal.name !== 'consent-term'"
      >
        <div
          class="form-group"
        >
          <label>
            {{ __('Máscara') }}

            <a
              target="_blank"
              rel="noopener noreferrer"
              v-b-tooltip.bottom="tooltip"
              class="form-builder-prop__info"
              href="https://salesflowcrm.movidesk.com/kb/article/405401/o-que-e-placeholder-e-mascara-para-que-servem"
            >
              <span
                class="form-builder-prop__info-trigger"
              >
                ?
              </span>
            </a>
          </label>

          <input
            type="text"
            name="mask"
            class="form-control"
            v-model="modal.mask"
          >
        </div>
      </div>

      <div
        class="col-md-12"
        v-if="modal.type !== 'label'"
      >
        <div
          class="form-group"
        >
          <label
            class="form-builder-prop__checkbox"
          >
            <input
              type="checkbox"
              @click="checkRequired()"
              :checked="requiredCheck"
            >

            {{ __('Campo obrigatório') }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '../../../sass/variables';

.form-builder-prop {
  display: flex;
  align-items: center;
  flex-flow: column nowrap;

  .row {
    width: 95%;
  }

  .col-md-12 {
    margin-bottom: 8px;
  }

  &__checkbox {
    display: flex;
    cursor: pointer;
    align-items: center;

    & > :first-child {
      margin-right: 4px;
    }
  }

  &__info {
    width: 37px;
    cursor: pointer;
    display: inline-block;

    &:hover {
      text-decoration: none !important;
    }

    &-trigger {
      width: 12px;
      color: $white;
      display: flex;
      font-size: 9px;
      font-weight: 500;
      align-items: center;
      border-radius: 14px;
      justify-content: center;
      background-color: $gray-light-2;
      font-family: $font-family-sans-serif;
    }
  }

  select {
    -webkit-appearance: none !important;
  }
}
</style>
